import React from 'react'
import { useInput } from 'react-admin'
import { getCurrentLang, useLangContext } from 'services/contexts/LangContext'
import {
  parseMultilangJSON,
  writeMultilangJSON,
} from 'services/utils/multilangParseWrite'
import { RAInputProps } from 'types/common'
import KRichTextInputMultilanguage from 'ui-shared/WrappedInputs/KRichTextInputMultilanguage'

const LocalizedRichInputText: React.FC<RAInputProps> = ({
  source,
  label,
  ...rest
}) => {
  const {
    field: { onChange, value },
  } = useInput({
    source,
  })
  // we're not using this hook state since we need the sync `getCurrentLang` output instead of it.
  // if we use hook state we'd receive the still-to-be-updated-value because of the async nature of the setLangContext() call
  // and Quill RichTextInput onchange() call
  useLangContext()
  const currentLang = getCurrentLang()
  const parsed = parseMultilangJSON(value)
  const handleLocalizedChange = (v: string) => {
    onChange(writeMultilangJSON(currentLang, v, parsed))
  }

  return (
    <KRichTextInputMultilanguage
      onChange={handleLocalizedChange}
      defaultValue={parsed[currentLang]}
      label={label}
      {...rest}
    />
  )
}

export default LocalizedRichInputText
